import styled from '@emotion/styled';

export const SectionContainer = styled.div<{ height?: string }>`
    display: flex;
    flex-direction: column;
    gap: 16px;
    height: ${({ height }) => height || 'auto'};
`;
